import { selectWarehouse } from 'containers/Warehouses/warehousesSlice'
import DeliveryPopup from 'components/popups/DeliveryPopup'
import { Action, getTotalDeposits } from '../core/utils'
import { useHistory, useParams } from 'react-router-dom'
import { SECTION_TYPES } from 'containers/Warehouse'
import ArrowBtn from 'components/buttons/ArrowBtn'
import { LOCATION_STATES } from 'utils/constants'
import useTranslation from 'hooks/useTranslation'
import BackBtn from 'components/buttons/BackBtn'
import usePopupState from 'hooks/usePopupState'
import { displayPrice } from 'utils/string'
import { useReduxSelector } from 'store'
import ReasonSelect from './ReasonSelect'
import Option from 'components/Option'
import React from 'react'

interface DefaultProps {
  isSending: boolean
  response?: payments.CancelRentalResponse
  selectedData: payments.SelectedData
  deliveries: payments.Delivery[]
  sendResignation: basic.BasicFunc
  selectData: React.Dispatch<React.SetStateAction<payments.SelectedData>>
  setDeliveries: React.Dispatch<React.SetStateAction<payments.Delivery[]>>
}

const Default: React.FC<DefaultProps> = ({ isSending, response, selectedData, deliveries, selectData, setDeliveries, sendResignation }) => {
  const { id } = useParams<warehouse.PageParams>()
  const warehouse = useReduxSelector(state => selectWarehouse(state, id))
  const { popup } = usePopupState()

  const { push, goBack } = useHistory()
  const { t } = useTranslation('warehouse')
  const openAction = (action: Action) => {
    push(`/warehouses/${id}/${SECTION_TYPES.cancel}/${action}`)
  }

  const deposit = getTotalDeposits(selectedData, response?.warehouses?.[0])
  const photosAdded = (selectedData.photos && selectedData.photos.length > 0) || (selectedData.documents && selectedData.documents.length > 0)
  const itemsToReturn = response?.warehouses?.[0]?.itemsToReturn?.map((item) => {
    const { id, name, deposit } = item
    const deliveryId = selectedData.itemsToReturn?.[id]
    return <Option
      key={id}
      selected
      title={`${t('return')} ${name}`}
      secondary={!!deliveryId}
      buttonText={t(deliveryId ? 'change' : 'return')}
      desc={`${t('depositCollected')}: ${displayPrice(deposit)}`}
      action={() => {
        push(window.location.pathname, LOCATION_STATES.popup({ type: 'returns', data: item } as unknown as string))
      }}
    />
  })

  return <>
    {(popup as any)?.type === 'returns' && <div>
      {((data: payments.CancelRentalResponseWarehouseReturn) => {
        return <DeliveryPopup
          popupName={t('returns')}
          price={data.deposit}
          cancelAction={goBack}
          productName={data.name}
          deliveryMethods={data.returnMethods}
          recentlySelectedDeliveries={deliveries}
          setRecentlySelectedDeliveries={setDeliveries}
          callback={({ deliveryId }) => {
            if (deliveryId) {
              selectData(prev => ({ ...prev, itemsToReturn: { ...(prev.itemsToReturn || {}), [data.id]: deliveryId } }))
            }
            goBack()
          }}
        />
      })((popup as any).data)}
    </div>}

    <div className='title'>
      <div>{t('resignationType.cancel')}</div>
      <div>{t('completeTheProcess')}</div>
    </div>

    <div className='resignation__main'>
      <div className='resignation__steps'>
        <ReasonSelect
          disabled={isSending}
          selectedData={selectedData}
          selectData={selectData}
        />

        <div className='title'>
          <div>{t('requiredActions')}</div>
          <div>{t('youMustCompleteTheseToCompleteTheRental')}</div>
        </div>

        <Option
          selected
          secondary={photosAdded}
          title={t('takeAPictureOfTheMAGIfYouOpenedIt')}
          desc={photosAdded
            ? `${t('added')} ${selectedData.photos?.length || selectedData.documents?.length} ${t('photos')}`
            : t('showTheStatusOfYourMag')}
          buttonText={t(photosAdded ? 'change' : 'add')}
          icon='add-photo'
          action={() => {
            openAction('camera')
          }}
        />
        <Option
          selected
          secondary={!deposit}
          title={t('payments')}
          buttonText={t('goTo')}
          desc={
            deposit > 0
              ? `${t('toBeReturned')} ${displayPrice(deposit)}`
              : t('everythingsAllRight')
          }
          icon='payments'
          action={() => {
            if (deposit) {
              openAction('summary')
            }
          }}
        />

        {itemsToReturn
          ? <>
            <p className='--center'>{t('chooseHowToReturnYourItems')}</p>
            {itemsToReturn}
          </>
          : null}
      </div>

      <div className='resignation__buttons'>
        <ArrowBtn
          enlarged
          text={t('confirm')}
          isLoading={isSending}
          action={sendResignation}
        />
        {(!warehouse.resignation || warehouse.resignation.canStop) && <BackBtn />}
      </div>
    </div>
  </>
}

export default Default